<template>
  <div
    class="-linked-fields-tags-menu"
    ref="container"
    :style="styleObject"
    :class="classList"
  >
    <div class="arrow" :style="arrowStyle"></div>
    <div class="-highlighter" :style="highlighterStyle" />
    <div>
      <div class="wt2-text-field -input">
        <div class="-tags-menu-input-title">Display Text:</div>
        <input
          ref="label"
          placeholder="Enter sample text..."
          v-model="label"
          :class="inputClass"
          style="padding: 5px 10px 5px 95px"
        />
      </div>
    </div>
    <div>
      <div
        class="wt2-text-field -linked-field -input"
        :class="{ '-with-link': !!value }"
        @click="openLinkedFieldsBrowser"
      >
        <div class="-tags-menu-input-title" v-if="value">Variable:</div>
        <span :class="['wticon', 'wticon-link2']" v-if="!value" />
        <input
          placeholder="Select Variable"
          ref="linkedField"
          v-model="value"
          tabindex="-1"
        />
        <div
          class="-remove-link"
          title="Remove Variable"
          @click="removeLink"
          v-if="!!value"
        >
          <i :class="['wticon', 'wticon-close_x']" />
        </div>
      </div>
      <linked-fields-tags-browser
        v-if="showLinkedFieldsBrowser"
        @cancel="closeLinkedFieldsBrowser"
        @selected="linkedFieldSelected"
        :linkedFields="linkedFieldsSchema"
        :options="{ label, value }"
      />
    </div>
    <wt-button
      class="-apply"
      type="primary"
      :text="actionLabel"
      :disabled="applyDisabled"
      @click="apply"
    />
  </div>
</template>

<script>
import LinkedFieldsTagsBrowser from './LinkedFieldsTagsBrowser.vue';
export default {
  name: 'LinkedFieldsMenu',
  components: {
    LinkedFieldsTagsBrowser,
  },
  data() {
    return {
      active: false,
      options: {},
      label: '',
      value: null,
      showLinkedFieldsBrowser: false,
      defaultActionLabel: 'Apply',
      actionLabel: 'Apply',
      guid: app.guid(),
      showTime: null,
      allowApplyWithoutVariable: false,
      inputClass: '-linked-field-input-' + Date.now(),
    };
  },
  methods: {
    removeLink(e) {
      e.stopPropagation();
      this.value = null;
    },
    linkedFieldSelected(payload) {
      this.value = payload.value;
      this.closeLinkedFieldsBrowser();
    },
    show(options) {
      this.active = true;
      this.options = options;
      this.label = options.label || '';
      this.value = options.value;
      this.actionLabel = options.actionLabel || this.defaultActionLabel;
      this.allowApplyWithoutVariable = !!options.editExisting;

      this.$nextTick(() => {
        this.showTime = Date.now();
        if (options.focusLabel) {
          this.$refs.label.focus();
        }
      });
    },
    close() {
      if (this.active) {
        this.active = false;
      }
    },
    apply() {
      this.$emit('apply', {
        label: this.label,
        value: this.value,
      });
    },
    openLinkedFieldsBrowser() {
      this.showLinkedFieldsBrowser = true;
    },
    closeLinkedFieldsBrowser() {
      this.showLinkedFieldsBrowser = false;
    },
    onDocumentMousedown(event) {
      if (!this.active) {
        return;
      }
      const isClickOutside = !this.$refs.container.contains(event.target);
      // const isTagClick = event.target.classList.contains('-tag');

      if (isClickOutside) {
        this.$emit('cancel');
      }
    },
    startListenToEscape(e) {
      const handlers = [
        {
          on: 'keydown',
          key: $.ui.keyCode.ESCAPE,
          run: (event) => {
            this.close();
          },
        },
      ];

      app.keyboardAccessibility.add(`-tags-menu-${this.guid}`, handlers);
    },
    stopListenToEscape(e) {
      app.keyboardAccessibility.remove(`-tags-menu-${this.guid}`);
    },
    onScroll(e) {
      if (
        !e?.target?.classList?.contains('tree') &&
        !e?.target?.classList?.contains(this.inputClass)
      ) {
        this.close();
      }
    },
    onWindowResize() {
      this.close();
    },
  },
  mounted() {
    this.actionLabel = this.defaultActionLabel;
    window.addEventListener('scroll', this.onScroll, true);
    document.addEventListener('mousedown', this.onDocumentMousedown);
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll, true);
    document.removeEventListener('mousedown', this.onDocumentMousedown);
    window.removeEventListener('resize', this.onWindowResize);
  },
  computed: {
    highlighterStyle() {
      const targetRect = this.targetRect || {};

      return {
        position: 'fixed',
        top: `${targetRect.top}px`,
        left: `${targetRect.left}px`,
        width: `${targetRect.width}px`,
        height: `${targetRect.height}px`,
        background: 'rgba(62, 189, 247, 0.25)',
        display: this.options.showHighlight ? 'block' : 'none',
      };
    },
    arrowStyle() {
      const targetRect = this.targetRect || {};
      const isOnTop = parseInt(this.styleObject.top) < this.targetRect.top;
      const style = {
        left: `${targetRect.width / 2 - 5}px`,
      };
      if (isOnTop) {
        style.bottom = '-10px';
        style.transform = 'rotate(180deg)';
      } else {
        style.top = '-10px';
      }
      return style;
    },
    linkedFieldsSchema() {
      return app.linkedFieldsSchema;
    },
    applyDisabled() {
      if (this.allowApplyWithoutVariable) {
        return _.isEmpty(this.label.trim());
      } else {
        return _.isEmpty(this.value) || _.isEmpty(this.label.trim());
      }
    },
    targetRectDimensions() {
      const targetRect = this.targetRect || {};
      const left = targetRect.x || 0;
      const top = targetRect.y + targetRect.height || 0;
      return {
        y: targetRect.y,
        x: targetRect.x,
        left,
        top,
        width: targetRect.width,
        height: targetRect.height,
      };
    },
    styleObject() {
      let positionStyle = {};

      if (this.showTime) {
        const containerRect = this.$refs.container
          ? this.$refs.container.getBoundingClientRect()
          : {};

        const tagsBrowserHeightDiff = 155;
        const arrowHeight = 15;
        const left = this.targetRectDimensions.left;
        let top = this.targetRectDimensions.top;

        if (
          containerRect.height + top + tagsBrowserHeightDiff >
          window.innerHeight
        ) {
          top =
            this.targetRectDimensions.y - containerRect.height - arrowHeight;
        } else {
          top += arrowHeight;
        }

        positionStyle = {
          left: `${left - 0}px`,
          top: `${top}px`,
        };

        if (this.options.fitTag) {
          positionStyle.width = `${this.targetRect.width}px`;
        }
      }

      return positionStyle;
    },
    classList() {
      return {
        '-active': this.active,
      };
    },
    targetRect() {
      if (this.options.targetRect) {
        return this.options.targetRect;
      } else if (this.options.$tagEl) {
        return this.options.$tagEl.getBoundingClientRect();
      } else {
        return {};
      }
    },
  },
  watch: {
    active() {
      if (this.active) {
        this.startListenToEscape();
      } else {
        this.stopListenToEscape();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.-linked-fields-tags-menu {
  width: 420px;
  height: 212px;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  display: none;
  font-size: 14px;
  position: fixed;
  z-index: 999999999999;
  padding: 20px;
  flex-direction: column;

  > div {
    position: relative;
  }

  &.-active {
    display: flex;
  }

  .arrow {
    position: absolute;
    left: 20px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
  }

  .-input {
    width: 100%;
    position: relative;
    margin-bottom: 20px;
    height: 40px;

    .-tags-menu-input-title {
      position: absolute;
      bottom: 12px;
      left: 5px;
      width: 80px;
      display: flex;
      align-items: center;
      pointer-events: none;
      font-weight: 500;
      font-size: 14px;
    }

    input {
      background: transparent;
      padding-left: 95px;
    }

    &.-linked-field {
      cursor: pointer;
      .wticon {
        font-size: 17px;
        margin-top: -2px;
        color: #06a9f4;
        left: 5px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      input {
        padding-left: 25px;
        pointer-events: none;
        color: #06a9f4;

        &::placeholder {
          color: #06a9f4;
        }
      }
      &.-with-link {
        input {
          padding-left: 75px;
        }
      }

      .-remove-link {
        position: absolute;
        right: 5px;
        bottom: 10px;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.3);

        .wticon {
          position: relative;
          transform: none;
          left: inherit;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.75);
        }

        &:hover {
          .wticon {
            color: rgba(0, 0, 0, 1);
          }
        }
      }
    }
  }

  .-apply {
    position: absolute;
    bottom: 20px;
    right: 20px;
    width: 100px;
    min-width: 100px;
    height: 40px;
    padding: 0;
  }
}
</style>
